module.exports = __webpack_public_path__ + "img/straddle.8bdc09df.png";